import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { intl } from '../../providers/IntlProvider';
import {
  getDefect,
  updateDefect,
  removeDefect,
} from '../../services/api';
import { newGetAllDefects } from '../../services/apiNew';
import { ToastCategories, ToastTypes, ToastsActionTypes } from '../toasts';
import { getPublicDefect } from '../../services/external';
import { WorkpacksActionTypes } from '../workpacks';
import { Defect, DefectAllResponse, DefectsActionTypes } from '.';

interface GetAllFleetDefectsPayload {
  page: number;
  limit: number;
  use_embeddings: boolean;
  status?: string[];
  type?: string[];
  deferred?: string[];
  aircraft?: string[];
  sort_column?: string;
  sort_order?: string;
  search?: string;
  aircraft_id?: string;
}


export const getAllFleetDefects =
  ({ payload }: { payload: GetAllFleetDefectsPayload }) =>
  async (dispatch: Dispatch): Promise<AxiosResponse<DefectAllResponse>> => {
    const response = await newGetAllDefects(payload);
    if (response) {
      const { status } = response;
      if (status && status > 199 && status < 399) {
        dispatch({
          type: DefectsActionTypes.SAVE_ALL,
          payload: { list: response.data.defects },
        });
      }
    }
    return response;
  };

export const getDefectForDrawer =
  (payload: { id: string }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await getDefect(payload);
    if (response && response.res.status > 199 && response.res.status < 399) {
      dispatch({
        type: DefectsActionTypes.SAVE,
        payload: response.data,
      });
    }
  };

export const update =
  ({ payload }: { payload: Defect }) =>
  async (dispatch: Dispatch): Promise<Defect> => {
    const response = await updateDefect(payload);
    if (response?.statusCode > 199 && response?.statusCode < 399) {
      dispatch({
        type: DefectsActionTypes.UPDATE_DRAWER_DEFECT,
        payload: [response?.body],
      });
      dispatch({
        type: DefectsActionTypes.SAVE,
        payload: [response?.body],
      });
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.defectUpdated' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.defectUpdateFail' }),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
    }
    return response;
  };
export const remove =
  ({ payload }: { payload: string }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await removeDefect(payload);
    if (response && response.statusCode === 204) {
      dispatch({
        type: DefectsActionTypes.REMOVE,
        payload: response
          ? {
              removeId: payload,
            }
          : {},
      });
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.defectDeleted' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.approveItemsError' }),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
    }
  };

export const getPublicDefectDetails =
  ({ payload }: { payload: { id: string; key: string } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await getPublicDefect(payload);
    // Despite being a defect API endpoint and it returns a workpack so we need to save
    // the against the workpack model/store.
    dispatch({
      type: WorkpacksActionTypes.SAVE_PUBLIC,
      payload: response,
    });
  };

export const handleCrsClicked =
  ({ payload }: { payload: boolean }) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: DefectsActionTypes.HANDLE_CRS_CLICKED,
      payload,
    });
  };
